import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'billboard',
  templateUrl: './billboard.component.html',
  styleUrls: ['./billboard.component.scss'],
})
export class BillboardComponent implements OnInit {
  @Input() title = '';
  @Input() height = '98%';
  @Input() width = '100%';
  @Input() color = 'var(--color-primary)';
  @Input() background = 'var(--color-primary-contrast)';

  constructor() {}

  ngOnInit(): void {}

  get styleData() {
    return {
      height: this.height,
      width: this.width,
      background: this.background,
      color: this.color,
    };
  }
}
